import { Nullable } from '@types'

export const sanitizeMessageHtml = (rawInput: string) => {
  const allowedTags = ['b', 'strong', 'i', 'em', 'ol', 'ul', 'li', 'br']
  const input = rawInput
    .replace(/<\/p><p>/g, '<br>')
    .replace(/^<p>/, '')
    .replace(/<\/p>$/, '')
    .replace(/<li><br><\/li>/g, '')

  const domParser = new DOMParser()
  const content = domParser.parseFromString(input, 'text/html')

  // Convert each ending </p> tag to a <br> tag
  const pElements = content.body.querySelectorAll('p')
  pElements.forEach((p, index) => {
    if (index !== pElements.length - 1) {
      // Don't add <br> for the last <p> element
      const br = document.createElement('br')
      p.parentNode!.insertBefore(br, p)
    }
    p.replaceWith(...Array.from(p.childNodes))
  })

  // Remove starting <br> if they exist
  if ((content.body?.firstChild as Nullable<HTMLElement>)?.tagName?.toLowerCase?.() === 'br') {
    ;(content.body.firstChild as HTMLElement).remove()
  }

  // Remove ending <br> if they exist
  if ((content.body?.lastChild as Nullable<HTMLElement>)?.tagName?.toLowerCase?.() === 'br') {
    ;(content.body.lastChild as HTMLElement).remove()
  }

  // Remove all tags not in the allowedTags list
  content.body.querySelectorAll('*').forEach(node => {
    if (!allowedTags.includes(node.tagName?.toLowerCase?.())) {
      node.replaceWith(...Array.from(node.childNodes))
    }
  })

  return content.body.innerHTML
}
